const IconLeftwardsArrow = ({
  width = "21",
  height = "21",
  fill = "#0179FF",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className ? className : null}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-name="IconLeftwardsArrow"
      data-flip="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70863 12.5476L11.8133 18.7525L9.60724 20.9947L1.57134 13.1448C0.366896 11.9683 0.366395 10.0311 1.57023 8.85391L9.60725 0.994758L11.8133 3.23701L5.72755 9.42264L20.9906 9.42264L20.9906 12.5476L5.70863 12.5476Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconLeftwardsArrow;